import { ReactNode } from "react";
import { Chip, ChipProps, TooltipProps } from "@mui/material";
import { EllipsisTooltip } from "../tooltip";

export type CoreChipProps = Omit<ChipProps, "variant" | "label" | "children"> & {
	variant?: "rectangular" | "rounded";
	mobileStyling?: boolean;
	children: ReactNode;
	chipColor: string;
	tooltip?: string;
	tooltipProps?: Omit<TooltipProps, "children" | "title" | "classes" | "PopperProps" | "componentsProps">;
};

export default function CoreChip({
	variant = "rounded",
	chipColor,
	mobileStyling,
	sx,
	children,
	tooltip,
	tooltipProps,
	...chipProps
}: CoreChipProps) {
	const labelContent = tooltip ? (
		<EllipsisTooltip {...tooltipProps} entry={tooltip}>
			<div>{children}</div>
		</EllipsisTooltip>
	) : (
		<div>{children}</div>
	);

	return (
		<Chip
			{...chipProps}
			label={labelContent}
			sx={{
				height: variant === "rectangular" ? "28px" : "22px",
				minWidth: mobileStyling ? `min(100%, 88px)` : "88px",
				fontSize: mobileStyling ? "13px" : "15px",
				fontWeight: mobileStyling ? 400 : 500,
				borderRadius: variant === "rectangular" ? "4px" : "16px",

				"& .MuiChip-label": {
					whiteSpace: "wrap",
				},

				backgroundColor: chipColor,
				...sx,
			}}
		/>
	);
}
